import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { companyService } from 'ogp/services';
import { CompanySettingsData } from '../settings-edit-page';

export const useUpdateCompanySettings = () => {
  const mutationFn = async (payload: CompanySettingsData) =>
    await companyService.updateCompanySettings(payload);
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => queryClient.invalidateQueries(QUERY_KEYS.companies()),
  });
};
